module.exports = __webpack_public_path__ + "img/demo-task.2ad08e94.svg";